<template>
  <div class="changestate">
    <ul class="changestateul">
      <li
        v-for="(tab, index) in tabs"
        :key="index"
        @click="toggle(index, tab.view)"
        :class="{ active: active == index }"
      >
        {{ tab.type }}
      </li>
    </ul>
    <div class="clearfix"></div>
    <!--:is实现多个组件实现同一个挂载点-->
    <component
      :is="currentView"
      @changeView="changeView"
      @changePhone="changePhone"
      :currentId="currentId"
      :phone="userInfo.phone"
      :studentNo="userInfo.studentNo"
    ></component>
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import SecuritySettingtab1 from "./SecuritySettingtab1";
import SecuritySettingtab2 from "./SecuritySettingtab2";
import SecuritySettingtab3 from "./SecuritySettingtab3";
export default {
  name: "ChangeState",
  components: {
    SecuritySettingtab1,
    SecuritySettingtab2,
    SecuritySettingtab3,
  },
  data: function () {
    return {
      active: 0,
      currentView: "SecuritySettingtab1",
      tabs: [
        {
          type: "绑定邮箱",
          view: "SecuritySettingtab1",
        },
        // {
        //   type: "绑定手机号",
        //   view: "SecuritySettingtab2",
        // },
        {
          type: "动态验证",
          view: "SecuritySettingtab3",
        },
      ],
      currentId: null,
    };
  },
  created() {
    // this.getApplyData();
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
    changeView(id) {
      console.log(id);
      this.currentView = "ViewTrack";
      this.active = 2;
      this.currentId = id;
    },
    changePhone(phone) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      console.log(userInfo);
      userInfo.phone = phone;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      this.changeUserInfo(userInfo)
    },
    ...mapMutations(['changeUserInfo'])
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;
  min-height: 800px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #fff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}

@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #fff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}

@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: $bgcontent;
  min-height: 500px;
  padding: 28px;

  .changestateul li {
    float: left;
    margin-right: 30px;
    width: 108px;
    height: 32px;
    line-height: 32px;
    background: #fff;
    color: #999999;
    cursor: pointer;
    text-align: center;
    border-radius: 3px;

    &.active {
      background: $bgColor;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/SecuritySetting.vue